import {
  AccountProductEnum,
  IInternalBankingAccount,
} from '@varo/graphql-schema-types';
import { Maybe } from 'shared/utils/types';

/*A customer can have many accounts that they can deposit into.  we should prioritize them in this order.
  1. if a id is provided to this screen from the disclosure screen use that
  2. any account marked as the default account
  3.  the first checking account we find.
  4. whatever is the first item in the array
*/
export function determineDefaultAccount(
  accounts: IInternalBankingAccount[],
  preSelectedAccount: string | null,
): Maybe<IInternalBankingAccount> {
  const defaultAccount = accounts.find((account) => account.isDefaultAccount);
  const firstCheckingAccount = accounts.find(
    (account) => account.product === AccountProductEnum.Checking,
  );
  const accountMatchesPreFetchedID = accounts.find(
    (account) => account.id === preSelectedAccount,
  );

  if (preSelectedAccount) {
    return accountMatchesPreFetchedID;
  } else if (defaultAccount) {
    return defaultAccount;
  } else if (firstCheckingAccount) {
    return firstCheckingAccount;
  } else if (accounts.length > 0) {
    return accounts[0];
  }
  return null;
}
